export const PAGE_VIEW_EXP_NAME = 'view-on-call-schedule';
export const FEEDBACK_COLLECTOR_LOCATION_VALUE = 'on-call-schedule';
